module.exports = __webpack_public_path__ + "static/vasiliy-94c34f5a38e8258ede594e837309b130.jpg";